export default {
  success: 'Payment successful',
  verifySuccess: 'Your email was changed successfully',
  title: 'Please verify account details',
  email: 'Email:',
  pleaseCheckEmail: '<b>Please check if the email address above is correct!</b> If the email address above is not correct',
  tapHere: 'tap here',
  changeYourEmail: 'Change Your Email Address',
  currentEmail: 'Current email',
  newEmail: 'New email',
  enterNewEmail: 'Enter new email',
  continue: 'Continue',
  submit: 'Submit'
}